var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"watermark",style:(_vm.watermarkStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }